/**
 * @license alexgorbatchev/node-crc v3.8.0
 * Copyright(c) 2014 Alex Gorbatchev
 * License: https://github.com/alexgorbatchev/node-crc/blob/v3.8.0/LICENSE
 * Full source: https://github.com/alexgorbatchev/node-crc/blob/v3.8.0/crc32.js
 */

/**
 *
 */
export default function (model, calc) {
  var fn = function fn(buf, previous) {
    return calc(buf, previous) >>> 0;
  };
  fn.signed = calc;
  fn.unsigned = fn;
  fn.model = model;
  return fn;
}